export default "__VITE_ASSET__47b66002__"